// 自动化测试段 —— 暂未实装。用户明确要求不要"瞎写" roadmap 卡片之类内容，
// 只显示一个干净的 Coming soon。等真做的时候再填功能 UI。

import React from 'react';

export const TestsSection = () => {
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 200px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
      }}
    >
      <div style={{ textAlign: 'center', color: 'var(--fg-3)', fontSize: 13 }}>
        Coming soon
      </div>
    </div>
  );
};
